<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-12-23 10:44:21
 * @FilePath: \mrc-ess-base-frontend\src\views\app_version_manage\modules\info.vue
 * @最后编辑: Betway
 * @最后修改时间: 2023-03-22 17:40:47
-->
<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <div data-app="true" class="app_version">
      <mrc_ess_iconGroup :is_disabled="disabled" @handleReturn="handleReturn" @handleEdit="handleEdit"
        @handleDel="handleDel"></mrc_ess_iconGroup>
      <v-form ref="app_version" v-model="app_Version">
        <v-card>
          <v-card-text>
            <mrc_ess_switch v-model="reqParams.is_forced_update" :true-value="1" :false-value="0" :readonly="disabled"
              :true-text="$t('label_appVersion_the_forced_update')"
              :false-text="$t('label_appVersion_the_forced_update')">
            </mrc_ess_switch>
            <v-row style="
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                  ">

              <v-col cols="12" sm="6">
                <mrc_ess_dictName v-model="reqParams.app_type" :disabled="disabled"
                  :label="$t('label_appVersion_the_apptype') + '*'" :rules="false"
                  :errMsg="$errors('reqParams', 'app_type', requiredRule)" dict_name="app_type" chips></mrc_ess_dictName>
              </v-col>
              <v-col cols="12" sm="6">
                <mrc_ess_dictName v-model="reqParams.device_type" :disabled="disabled"
                  :label="$t('label_appVersion_the_devicetype') + '*'" :rules="false"
                  :errMsg="$errors('reqParams', 'device_type', requiredRule)" dict_name="device_type" chips>
                </mrc_ess_dictName>
              </v-col>
              <v-col cols="12" sm="6">
                <mrc_ess_multiText :label="$t('label_appVersion_the_shwo_versioncode') + '*'"
                  :isNational="judegNational('show_version_code')" :readonly="disabled" style="width: 100%"
                  :error-messages="
                    $errors(
                      'reqParams',
                      'show_version_code',
                      requiredRule.concat(nocharacter)
                    )
                  " v-model="reqParams.show_version_code"></mrc_ess_multiText>
              </v-col>
              <v-col cols="12" sm="6">
                <mrc_ess_NumInput :readonly="disabled" :error-messages="
                  $errors(
                    'reqParams',
                    'determine_version_code',
                    between('0-999').concat(requiredRule)
                  )
                " :label="
  $t('label_appVersion_the_determine_versioncode') + '*'
" v-model="reqParams.determine_version_code"></mrc_ess_NumInput>
              </v-col>
              <v-col cols="12" sm="12">
                <mrc_ess_multiText :label="$t('label_appVersion_the_appurl') + '*'" :isNational="judegNational('app_url')"
                  :readonly="disabled" style="width: 100%" :error-messages="
                    $errors(
                      'reqParams',
                      'app_url',
                      requiredRule.concat(nocharacter)
                    )
                  " v-model="reqParams.app_url"></mrc_ess_multiText>
              </v-col>
              <v-col cols="12" sm="12">
                <mrc_ess_multiText textarea noRequired v-model="reqParams.remarks" :isNational="judegNational('remarks')"
                  :readonly="disabled" :label="$t('label_note')"></mrc_ess_multiText>
              </v-col> </v-row>
          </v-card-text></v-card>
        <mrc_ess_submitBtn v-show="!disabled" :loading="loading" @cancel="cancel" @success="success"></mrc_ess_submitBtn>
      </v-form>
    </div>
  </mrc_ess_skeleton_loader>
</template>
<script>
import {
  get_version_detail,
  getDelete,
  getAdd,
  getChange,
} from "@/service/api/app_version";
import { required, between } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      skLoading: true,
      loading: false,
      app_Version: true,
      is_change: 1, // 是否有删除的权限
      isLoading: false,
      is_return: false,
      isOpen: false,
      disabled: false,
      is_used: true,
      params: {
        "~table~": "mrbase_sys_app_version_upgrade",
      },
      reqParams: {
        "~table~": "mrbase_sys_app_version_upgrade",
        uuid: "",
        is_forced_update: 0,
        app_url: "", //升级url
        app_type: "", // app类型
        device_type: "", // 设备类型
        show_version_code: "", //展示版本号
        determine_version_code: 0, // 判断版本号
        remarks: "", //备注
      },
    };
  },
  validations: {
    reqParams: {
      device_type: {
        required,
      },
      app_type: {
        required,
      },
      show_version_code: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      app_url: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      determine_version_code: {
        required,
        between: between(0, 9999),
      },
    },
  },
  async mounted() {
    // 有uuid传过来 就是修改
    await this.national("mrbase_sys_app_version_upgrade");
    this.skLoading = true;
    // const name = this.$store.getters.subPage_name
    const uuid = this.$route.params.uuid || this.$store.state.uuid;
    const is_change =
      this.$route.params.is_change || this.$store.state.is_change;
    if (is_change == 1) {
      this.is_change = is_change;
    }
    if (uuid) {
      if (this.$store.state.iconstatus) {
        this.disabled = true;
      }
      this.reqParams.uuid = uuid;

      // 查询详情
      const detailObj = await get_version_detail({
        uuid: this.reqParams.uuid,
        "~table~": "mrbase_sys_app_version_upgrade",
      });
      this.reqParams = detailObj.data;
    } else {
      this.disabled = false;
    }
    this.skLoading = false;
  },
  methods: {
    // 点击修改icon
    handleEdit() {
      this.disabled = !this.disabled;
    },
    // 点击返回上一页
    handleReturn() {
      this.$router.go(-1);
    },
    // 点击删除此参照
    handleDel() {
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(async () => {
          const obj = Object.assign(
            {},
            {
              uuid: this.reqParams.uuid,
              "~table~": "mrbase_sys_app_version_upgrade",
            }
          );
          const res = await getDelete(obj);
          if (res.code == 200) {
            // console.log(this.$parent.desserts.length, this.$parent.params.cpage)
            // if (
            //   this.$parent.desserts.length === 1 &&
            //   this.$parent.params.cpage > 1
            // ) {
            //   this.$parent.params.cpage--
            //   this.$parent.params.totalpage--
            // }

            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
          }
          this.$router.go(-1);
        })
        .catch(() => { });
      // this.isOpen = true
      // this.showText = this.$t('info.is_del')
    },
    // 取消 修改或者添加
    async cancel() {
      if (this.reqParams.uuid) {
        const detailObj = await get_version_detail({
          uuid: this.reqParams.uuid,
          "~table~": "mrbase_sys_app_version_upgrade",
        });
        this.reqParams = detailObj.data;
        this.disabled = true;
      } else {
        const uuid = this.$route.params.uuid || this.$store.state.uuid;
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then(() => {
            this.$router.go(-1);
          })
          .catch(() => { });
      }
    },
    // 提交
    async success() {
      this.$v.reqParams.$touch();
      const isSubmit = this.$refs.app_version.validate();
      if (!isSubmit || this.$v.reqParams.$error) {
        return;
      }
      this.isLoading = true;
      let obj = this.$clone(this.reqParams);
      // return
      // 修改
      this.loading = true;
      if (this.reqParams.uuid) {
        const res = await getChange({
          "~table~": this.params["~table~"],
          uuid: obj.uuid,
          app_url: obj.app_url,
          app_type: obj.app_type,
          is_forced_update: obj.is_forced_update,
          device_type: obj.device_type,
          show_version_code: obj.show_version_code,
          determine_version_code: obj.determine_version_code,
          remarks: obj.remarks,
        });
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
          this.disabled = true;
        }
        this.loading = false;
      } else {
        // 添加
        const res = await getAdd({
          "~table~": this.params["~table~"],
          //   uuid: obj.uuid,
          app_url: obj.app_url,
          app_type: obj.app_type,
          is_forced_update: obj.is_forced_update,
          device_type: obj.device_type,
          show_version_code: obj.show_version_code,
          determine_version_code: obj.determine_version_code,
          remarks: obj.remarks,
        });
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
          this.$router.go(-1);
        } else {
        }
        this.loading = false;
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.app_version /deep/ .v-menu__content {
  min-width: 400px !important;
}

.iconGroup {
  position: relative;
}

.returnBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 130px;
}

.editBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 70px;
}

.delBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 10px;
}
</style>